/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { CreateBotOptions, CreateBotResponses } from '../types/CreateBot'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Create a new bot
 * {@link /v1/bots}
 */
export function createBot<ThrowOnError extends boolean = true>(
  options: Options<CreateBotOptions, ThrowOnError>,
): Unwrappable<RequestResult<CreateBotResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/bots',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<CreateBotResponses, ThrowOnError>>,
  )
}
